<template>
    <div :class="containerClass">
        <flat-pickr
            :name="id"
            :model-value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            :config="datePickerConfig"
            class="
                shadow-sm
                focus:ring-indigo-500 focus:border-indigo-500
                block
                w-full
                sm:text-sm
                border-gray-300
            "
            :placeholder="placeholderText"
        />
    </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";

// :model-value="modelValue"
// @update:model-value="modelValue = $event"

// :value="modelValue"
// @input="$emit('update:modelValue', $event.target.value)"

export default {
    components: {
        flatPickr,
    },
    data() {
        return {
            datePickerConfig: {
                enableTime: true,
                altFormat: "d F Y, h:i K",
                altInput: true,
                dateFormat: "d F Y H:i",
                defaultDate: new Date(),
            },
        };
    },
    props: [
        "modelValue",
        "id",
        "label",
        "subtitle",
        "placeholderText",
        "containerClass",
    ],
    emits: ["update:modelValue"],
};
</script>
